// extracted by mini-css-extract-plugin
export default {"logo":"KeypadButton_logo__jIAiv","keypadButton":"KeypadButton_keypadButton__bDD9C","smallKeypadButton":"KeypadButton_smallKeypadButton__C4NCV","keypad":"KeypadButton_keypad__FcZQT"};